import { render, staticRenderFns } from "./FormContainer.vue?vue&type=template&id=2be5f464&scoped=true"
import script from "./FormContainer.vue?vue&type=script&lang=js"
export * from "./FormContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be5f464",
  null
  
)

export default component.exports